import {KennethMustDie} from "../KennethMustDie";
import {KMD_SYMBOL_ANIMATIONS} from "../server/IKMDData";
import {KMDSound} from "../sound/KMDSound";

export class KMDStickyXH extends PIXI.Container {
    private readonly _xH: PIXI.spine.Spine;
    private readonly _lock: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "KMDStickyXH";

        this._xH = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("XH"));
        this._xH.visible = false;

        this._lock = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("locks"));
        this._lock.visible = false;

        this.position.set(360, 313.5);

        this.addChild(this._xH, this._lock);
    }

    public showStickyXH(): void {
        this._xH.visible = true;
        this._xH.updateTransform();
        this._xH.state.setAnimation(0, KMD_SYMBOL_ANIMATIONS.NORMAL, false);

        this.showLock();
    }

    public hideStickyXH(): void {
        this._xH.visible = false;
        this._xH.state.clearTracks();

        this.hideLock();
    }

    public hideLock(): void {
        if (this._lock.visible) {
            this._lock.state.clearTracks();

            // #480
            KennethMustDie.soundPlayer.playSound(KMDSound.CHAINED_UNLOCKED);

            KennethMustDie.createTimelineForAnimation(this._lock, 0, "locked_150_disappear", false).eventCallback("onComplete", () => {
                this._lock.visible = false;
            });
        }
    }

    private showLock(): void {
        if (!this._lock.visible) {
            this._lock.visible = true;
            this._lock.updateTransform();

            KennethMustDie.createTimelineForAnimation(this._lock, 0, "locked_150_start", false).eventCallback("onComplete", () => {
                this._lock.autoUpdate = true;

                this._lock.state.setAnimation(0, "locked_150", true);
            });
        }
    }
}